/** Ninja risk score — first present key across deployments. */
const NINJA_RISK_SCORE_KEYS = [
  'ninja_risk_score',
  'ninja_score',
  'ninjaedge_score',
  'ninja_edge_score',
  'risk_score',
  'ibv_risk_score',
] as const

export function readNinjaRiskScore(row: Record<string, unknown> | null | undefined): string {
  if (!row || typeof row !== 'object') return ''
  for (const key of NINJA_RISK_SCORE_KEYS) {
    const v = row[key]
    if (v !== undefined && v !== null && String(v).trim() !== '') return String(v)
  }
  return ''
}

export function readEquifaxScore(row: Record<string, unknown> | null | undefined): string {
  if (!row || typeof row !== 'object') return ''
  const v = row.equifax_score
  if (v !== undefined && v !== null && String(v).trim() !== '') return String(v)
  return ''
}
